import { makeAutoObservable, toJS } from 'mobx';

import { getConfig } from '@constants';

import { Log } from '@utils';

import { Api } from '@api';

import { getAdaptedUser } from '../utils';

import { IApiResponse } from '@interfaces';
import { IUser } from '@interfaces/IUser';

import { ICurrentUserStoreActionAuthParams, ICurrentUserStoreJSON } from './types';

const initialUser: IUser = {
	id: null,
	email: null,
	isMyDeleted: null,
	avatar: {
		changeTime: null, // добавить в путь до картинки, чьтобы показать верный аватар при его замене юзером (иначе мешает кэш)
		url: {
			size180: null,
			size45: null,
			size32: null,
			size600: null,
			size90: null,
		},
	},
	name: {
		first: null,
		last: null,
		full: null,
	},
	isFemale: null,
	age: null,
	createTime: null,
	auid: null,
	isMyCreated: null,
	isVip: null,
	isAdvFree: null,
	locale: null,
	dir: null,
	count: {
		friends: null,
		follows: null,
	},
	timezone: null,
	isOldVerified: null,
	sumMailiki: null,
	isShowAge: null,
	isInSandbox: null,
	isNeedVerify: null,
	magicNumber: {
		a: null,
		b: null,
	},
	isAdmin: null,
};

interface ICreateMy {
	data?: { create_my: number };
}

export class CurrentUserStore {

	currentUser: IUser = initialUser;

	constructor() {
		makeAutoObservable(this);
	}

	get isUserAuth() {
		return Boolean(this.currentUser.email);
	}

	get isMyCreated() {
		return Boolean(this.currentUser.isMyCreated);
	}

	setCurrentUser(currentUser: IUser) {
		this.currentUser = currentUser;
	}

	async fetchUser(tries = 0): Promise<IUser> {
		let currentUser: IUser;

		const isComeFromAuthPage = getConfig().referrer?.includes('account.mail.ru');

		try {
			const { data: currentUserData } = (await Api.currentUser.getCurrentUser())?.data || {};

			if (currentUserData && Object.keys(currentUserData).length > 0) {
				currentUser = currentUserData;
			}
		} catch (err) {}
		if ((!currentUser || !currentUser?.isMyCreated) && isComeFromAuthPage) {
			if (tries < 3) {
				let isNewWorldCreated = false;

				try {
					const newWorldResp: IApiResponse<ICreateMy> = await Api.currentUser.createMy();

					isNewWorldCreated = newWorldResp?.data?.data?.create_my === 1;
				} catch (err) {
					Log.warn(`Can't create world. ${err};`);
				}

				if (isNewWorldCreated) {
					return await this.fetchUser(tries++);
				}
			}
		} else {
			return currentUser;
		}
	}

	async fetchCurrentUser() {
		try {
			const currentUserData = await this.fetchUser();

			if (currentUserData && Object.keys(currentUserData).length > 0) {
				this.setCurrentUser(getAdaptedUser(currentUserData));
				Log.setUserId(this.currentUser.id);
			}
		} catch (e) {
			Log.warn(`No auth user. ${e.serverError?.errorDescription};`);
		}

		if (!getConfig().isProcessingSdc) {
			try {
				await Api.currentUser.sdc();
			} catch (err) {
			}
		}
	}

	async localAuth(params: ICurrentUserStoreActionAuthParams) {
		try {
			return await Api.currentUser.auth({
				Login: params.login,
				Domain: params.domain,
				Password: params.password,
				page: getConfig().hosts.baseUrl,
			});
		} catch (err) {
			Log.message('wrong login or password');
		} finally {
			return await Api.currentUser.sdc();
		}
	}

	logout() {
		this.setCurrentUser(initialUser);
	}

	toJSON(): ICurrentUserStoreJSON {
		return {
			currentUser: this.currentUser,
		};
	}

	fromJSON(data: ICurrentUserStoreJSON): void {
		this.currentUser = { ...toJS(this.currentUser), ...data.currentUser };
	}

}
